import React from "react";
import { Box, Flex, ListItem, Text, UnorderedList } from "@chakra-ui/react";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import ButtonizedTooltip from "@/shared/components/ButtonizedTooltip";
import BankAccountInfoTooltipContent from "@/features/my-order/components/BankAccountInfoTooltipContent";
import { Trans } from "react-i18next";

function SettlementManagementTooltipHeader() {
  const { tTitle, tSentence } = useI18nHelper();

  return (
    <Flex
      gap={"12px"}
      alignItems={"center"}
      textStyle={"body-sm-bold"}
      color={"#444444"}
      paddingY={"4px"}
      justifyContent={"end"}
    >
      <Flex gap={"4px"} alignItems={"center"}>
        <ButtonizedTooltip
          label={tTitle("settlement:what_is_fee")}
          contentProps={{
            width: "440px",
          }}
        >
          <Flex flexDirection={"column"} gap={"16px"}>
            <Flex flexDirection={"column"} gap={"4px"}>
              <Text textStyle={"body-sm-bold"} color={"#363636"}>
                Q.{tSentence("settlement:fee_tooltip.what_is_fee_question")}
              </Text>
              <Text textStyle={"body-sm-regular"} color={"#444444"}>
                A.{tSentence("settlement:fee_tooltip.what_is_fee_answer")}
              </Text>
            </Flex>
            <Flex flexDirection={"column"} gap={"4px"}>
              <Text textStyle={"body-sm-bold"} color={"#363636"}>
                Q.
                {tSentence(
                  "settlement:fee_tooltip.how_fee_calculated_question"
                )}
              </Text>
              <Text textStyle={"body-sm-regular"} color={"#444444"}>
                A.
                {tSentence("settlement:fee_tooltip.how_fee_calculated_answer")}
              </Text>
            </Flex>
            <Flex flexDirection={"column"} gap={"4px"}>
              <Text textStyle={"body-sm-bold"} color={"#363636"}>
                Q.{tSentence("settlement:fee_tooltip.when_how_remit_question")}
              </Text>
              <Box>
                <Text textStyle={"body-sm-regular"} color={"#444444"}>
                  A.{tSentence("settlement:fee_tooltip.when_how_remit_answer")}
                </Text>
                <UnorderedList textStyle={"body-sm-regular"} color={"#444444"}>
                  <ListItem>
                    <Trans
                      i18nKey="settlement:fee_tooltip.when_how_remit_answer.billing_schedule"
                      components={{
                        span: (
                          <Box
                            as={"span"}
                            textStyle={"body-sm-bold"}
                            color={"#363636"}
                          />
                        ),
                      }}
                    />
                  </ListItem>
                  <ListItem>
                    <Trans
                      i18nKey="settlement:fee_tooltip.when_how_remit_answer.remittance_due"
                      components={{
                        span: (
                          <Box
                            as={"span"}
                            textStyle={"body-sm-bold"}
                            color={"#363636"}
                          />
                        ),
                      }}
                    />
                  </ListItem>
                </UnorderedList>
              </Box>
            </Flex>
          </Flex>
        </ButtonizedTooltip>
      </Flex>
      <Flex gap={"4px"} alignItems={"center"}>
        <ButtonizedTooltip label={tTitle("settlement:bank_account_info")}>
          <BankAccountInfoTooltipContent />
        </ButtonizedTooltip>
      </Flex>
    </Flex>
  );
}

export default SettlementManagementTooltipHeader;
